import toast from 'lib/toast'
import { type FetchFunc } from 'types/util'
import { messageFromResponseError } from 'utils/strings'

/**
 * Handles API calls that refetch data that results in a page reload.
 *
 * Rationale:
 * Often, we make API calls to change a backend record.
 * We don't want the user to get a failure message because we couldn't refetch data.
 */
export async function handleDataFetchOnChange<T = unknown>(
  onChange: FetchFunc<T>,
  fallbackErrorMessage?: string
) {
  try {
    await onChange()
  } catch (err) {
    toast({
      type: 'error',
      text: messageFromResponseError(
        err,
        fallbackErrorMessage ?? 'There was an issue, try reloading the page.'
      )
    })
  }
}
